<template>
  <div class="duanwu" id="duanwu">
    <!-- ps img -->
    <div class="con-imgs-box">
      <img class="con-img" v-for="(item,index) in 30" :src="getConImgUrl(item)" :key="index">
    </div>
  </div>
</template>
<script>
export default {
  name: "duanwu",
  data() {
    return {
      msg: "duanwu page"
    };
  },
  methods: {
    getConImgUrl(item) {
      return require("../assets/img/duanwu/duanwu_ps_" +
        (item > 9 ? item + "" : "0" + item) +
        ".jpg");
    }
  }
};
</script>
<style lang="less" scoped>
.con-imgs-box {
  .con-img {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
  }
}
</style>

